<!-- Language Basic Style -->
<div *ngIf="style == 'basic'" (clickOutside)="hideDropdown()">
    <app-ds-button
      type="button"
      tone="ghost"
      size="sm"
      class="btn dropdown-toggle"
      [id]="'open_dropdown_basic_btn'"
      (pressed)="openDropDown()">
      <span><div class="iti-flag {{ selectedLanguage.icon }}"></div> {{ selectedLanguage.language }}</span>
    </app-ds-button>
    <ul class="dropdown-menu dropdown-menu-end language-dropdown" [class.show]="active" >
        <li *ngFor="let language of languages">
            <a class="dropdown-item" href="javascript:void(0)" (click)="selectLanguage(language)">
              <div class="iti-flag {{ language.icon }}"></div>
              <span>{{ language.language }}</span>
            </a>
        </li>
    </ul>
</div>
<!-- Language Standard Style -->
<div *ngIf="style == 'standard'" (clickOutside)="hideDropdown()">
    <app-ds-button
      type="button"
      tone="ghost"
      size="sm"
      class="dropdown-toggle"
      [id]="'open_dropdown_standard_btn'"
      (pressed)="openDropDown()">
      <span><div class="iti-flag {{ selectedLanguage.icon }}"></div> {{ selectedLanguage.language }}</span> <i class="ri-arrow-{{ active ? 'up' : 'down' }}-s-line"></i>
    </app-ds-button>
    <ul class="dropdown-menu" [class.show]="active">
        <li *ngFor="let language of languages">
            <a class="dropdown-item" href="javascript:void(0)" (click)="selectLanguage(language)">
              <div class="iti-flag {{ language.icon }}"></div>
              <span>{{ language.language }}</span>
            </a>
        </li>
    </ul>
</div>
